export default __webpack_public_path__ + "static/media/feed_success.a47ed19e.mp3";